<template>
  <q-card flat>
    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm">
        <!-- <PageTitleVue title="科室管理"> 
        </PageTitleVue> -->
        <q-input
          outlined
          class="col-2"
          dense
          v-model="FilterString"
          label="机构名称"
          color="primary"
        />
        <q-btn
          color="primary"
          icon="search"
          @click="onLoadData"
          :loading="PdmConfigKeyListLoading"
          style="height: 38px;"
        >
          查询
        </q-btn>
        <q-space />
        <!-- <q-btn color="primary" icon="download" style="height: 38px;" @click="onDownload" :loading="PdmConfigKeyListLoading">
              下载
            </q-btn>
            <q-btn color="primary" style="height: 38px" icon="fas fa-file-excel" :loading="PdmConfigKeyListLoading" @click="onExportData">导出</q-btn> -->
        <q-btn
          color="primary"
          style="height: 38px"
          icon="note_add"
          :loading="PdmConfigKeyListLoading"
          @click="onAdd"
          >新增</q-btn
        >
      </div>
      <vxe-grid
        v-bind="gridOptions"
        :sort-config="{ multiple: true }"
        :custom-config="{ storage: true }"
        id="custom-config"
        :export-config="gridOptions.tableExport"
        :height="$store.getters.maxPageHeight - 140"
        :loading="PdmConfigKeyListLoading"
        highlight-current-row
        size="mini"
      >
        <template #toolbar_buttons id="custom-config"> </template>
        <template #operate="{ row }">
          <vxe-button
            flat
            color="primary"
            icon="fas  fa-edit"
            @click="onEdit(row)"
            >编辑</vxe-button
          >
          <vxe-button
            flat
            color="negative"
            icon="fas fa-trash"
            @click="onDelete(row)"
            >删除</vxe-button
          >
        </template>
      </vxe-grid>
      <vxe-pager
        perfect
        size="mini"
        :page-sizes="tablePage.pageSizes"
        v-model:current-page="tablePage.currentPage"
        v-model:page-size="tablePage.pageSize"
        :total="tablePage.totalResult"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      >
      </vxe-pager>
    </q-card-section>
  </q-card>

  <q-dialog v-model="pdmConfigKeyshowDlg" persistent>
    <ConfigKeyEdit @onLoadData="onLoadData" />
  </q-dialog>

  <q-dialog v-model="addPdmConfigKeyShowDlg" persistent>
    <AddConfigKey @onLoadData="onLoadData" />
  </q-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import XEUtils from "xe-utils";
import ConfigKeyEdit from "./configKeyEdit.vue";
import AddConfigKey from "./addConfigKey.vue";
//import PageTitleVue from "@/views/comm/pageTitle.vue";
export default {
  components: {
    ConfigKeyEdit,
    AddConfigKey,
    //PageTitleVue
  },
  computed: {
    ...mapState("PdmConfigKey", [
      "PdmConfigKeyList",
      "PdmConfigKeyListLoading",
      "PdmConfigKeyEntity",
      "PdmConfigKeyShowDlg",
      "AddPdmConfigKeyShowDlg",
    ]),

    pdmConfigKeyshowDlg: {
      get() {
        return this.PdmConfigKeyShowDlg;
      },
      set(val) {
        console.log(val);
        this.$store.commit("PdmConfigKey/setPdmConfigKeyShowDlg", val);
      },
    },
    addPdmConfigKeyShowDlg: {
      get() {
        return this.AddPdmConfigKeyShowDlg;
      },
      set(val) {
        console.log(val);
        this.$store.commit("PdmConfigKey/setAddPdmConfigKeyShowDlg", val);
      },
    },
  },
  data() {
    return {
      FilterString: "",
      tablePage: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
        pageSizes: [15, 20, 50, 100, 5000],
      },
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        highlightHoverRow: true,
        align: "left",
        toolbarConfig: {
          perfect: true,
          print: true,
          zoom: true,
          custom: true,
          export: true,
          slots: {
            // 自定义工具栏模板
            buttons: "toolbar_buttons",
          },
        },
        //点击编辑必须配置
        // editConfig: {
        //   trigger: "click",
        //   mode: "cell",
        //   activeMethod: () => {
        //     if (this.lockData) return false;
        //     return true;
        //   },
        // },
        tableExport: {},
        columns: [
          { type: "seq", width: 50, align: "center" },
          {
            field: "HOSPNAME",
            title: "机构名称",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "CONFIG_KEY_NO",
            title: "模块序号",
            sortable: true,
            align: "left",
            width: 100,
          },
          {
            field: "CONFIG_KEY_NAME",
            title: "模块名称",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "CONFIG_KEY_IS_SWITCH_Name",
            title: "是否启用",
            sortable: true,
            align: "center",
            width: 100,
          },
          {
            title: "操作",
            width: 200,
            slots: { default: "operate" },
            align: "center",
            fixed: "right",
          },
          //   {
          //     field: "CatName",
          //     title: "类别",
          //     sortable: true,
          //     editRender: { name: "input" },//点击编辑必须配置
          //     slots: { edit: "CatName" },//点击编辑必须配置
          //     align: "left",
          //     width: 140,
          //   },
        ],
        // data: this.PdmConfigKeyList,
        data: null,
      },
    };
  },
  mounted() {
    this.onLoadData();
  },
  methods: {
    ...mapActions("PdmConfigKey", [
      "actGetPdmConfigKeyListByPage",
      "actCreatePdmConfigKey",
      "actEditPdmConfigKeyData",
      "actEditPdmConfigKey",
      "actDeletePdmConfigKey",
    ]),
    onLoadData() {
      this.actGetPdmConfigKeyListByPage({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        FilterString: this.FilterString,
        PageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
      })
        .then((res) => {
          this.gridOptions.data = res.Data;
          this.tablePage.totalResult = res.Count;
        })
        .finally(() => {
          this.$store.commit("PdmConfigKey/setPdmConfigKeyListLoading", false);
          //this.PdmConfigKeyListLoading = false;
        });
    },
    onAdd() {
      this.$store.commit("PdmConfigKey/setAddPdmConfigKeyShowDlg", true);
    },
    onEdit(e) {
      var obj = {};
      Object.assign(obj, e);
      this.actEditPdmConfigKey(obj);
    },
    onDelete(e) {
      this.actDeletePdmConfigKey({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: e,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
        }
      });
    },
    //onExportData:{},
    //需要合计：表头必须添加 :footer-method="footerMethod" 跟 show-footer
    footerMethod({ columns, data }) {
      var list = ["PRIC"]; //需要汇总的字段
      const footerData = [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (list.includes(column.property)) {
            return XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
      return footerData;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.onLoadData();
    },
  },
};
</script>
